import { call, put, takeLatest } from "@redux-saga/core/effects";
import { NavigationConstant } from "./NavigationConstant";
import { NavigationApiData } from "./NaviagtionApi";
import { NavigationParser } from "./NavigationParser";
function* getNavigationData({ payload }) {
  let {from_date,to_date,search_term, page, limit,sorting} = payload;

  try {
    yield put({ type: NavigationConstant.NAVIGATION_REQUEST });
    const res = yield call(NavigationApiData.getNavigationApiData, {
      to_date,
      from_date,
      search_term,
      page,
      limit,
      sorting
    });
    console.log('res',res);
    const payload = NavigationParser.getNavigationParser(res);
      
    yield put({
      type: NavigationConstant.NAVIGATION_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: NavigationConstant.NAVIGATION_RESPONSE,
      payload: [],
    });
  }
}


export function* NavigationDataSaga() {
  yield takeLatest(NavigationConstant.NAVIGATION_SAGA, getNavigationData);
}
